import { CompareBarChartWrapper } from '@modules/quantify/components/QuantifyChart/CompareBarChartWrapper';
import { QuantifyChartProps } from '@modules/quantify/components/QuantifyChart/QuantifyChart';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { Box } from '@mui/material';

export function CompareAggregateFormulaValueBarChart({
  component,
  shouldDisableInteraction,
}: QuantifyChartProps = {}) {
  const valueRange = useQuantifyStore(
    ({ reportData }) => reportData.compare.valueRange,
  );

  return (
    <Box sx={component?.compareBarChart?.containerSxProps}>
      <CompareBarChartWrapper
        shouldShowToggleGroup={false}
        shouldShowAddToFilter={false}
        shouldShowTitle={false}
        shouldDisableInteraction={shouldDisableInteraction}
        chartHeight={component?.compareBarChart?.chartHeight}
        barLabelSxProps={component?.compareBarChart?.barLabelSxProps}
        shouldShowAddToFilterForBothCompareFields={false}
        yAxis={{ tick: false, label: '', dataKey: 'label' }}
        xAxis={{
          domain: valueRange ? [valueRange.start, valueRange.end] : undefined,
          dataKey: 'prevValue',
        }}
        shouldTakeFullHeight={component?.compareBarChart?.shouldTakeFullHeight}
      />
    </Box>
  );
}
